<nav class="navbar fixed-top navbar-expand-lg" style="min-width: 350px; z-index: 999 !important;">
  <div class="container-fluid">
    <a href="systemsList" style="text-decoration: none;">
      <img src="assets/img/logo.png" class="navbarLogo">
    </a>

    <div class="d-flex align-items-center justify-content-end">
      <app-language *ngIf="isToggle" class="me-1"></app-language>
      <button class="navbar-toggler custom-toggler mr-2" type="button" data-bs-toggle="collapse"
        data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <i class="bi bi-list"></i>
      </button>
    </div>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-auto">
        <li *ngFor="let menu of (menuNavbar$ | async)" class="nav-item d-flex align-items-center mb-1 me-4 ms-1"
          [ngClass]="{'ms-2': isToggle}">
          <a class="nav-link" [routerLink]="[menu.path]" *ngIf="menu.id > 0"
            [ngStyle]="{'border-bottom': isCurrentPage(menu ? menu.path : '') ? '2px solid #FF0000' : 'none'}">
            <!-- {{'NAVBAR.SYSTEMS' | translate}} -->
            <span *ngIf="menu.voice == 'Systems'; else systemVoice">
              {{'NAVBAR.SYSTEMS' | translate}}
            </span>
            <ng-template #systemVoice>
              {{menu.voice}}
            </ng-template>
          </a>
          <a class="nav-link" [href]="menu.path" target="_blank" *ngIf="menu.id == 0">
            <span *ngIf="menu.voice == 'Monitoring'">
              {{'NAVBAR.MONITORING' | translate}}
            </span>
          </a>
        </li>
        <li *ngIf="!isToggle" class="nav-item d-flex align-items-center mb-1 mr-4"
          [ngStyle]="{'border-bottom': isCurrentPage('/profile') ? '2px solid #FF0000' : 'none'}">
          <div class="dropdown">
            <button class="btn profileButton nav-link dropdown-toggle" id="navbarDropdown" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-person mr-2"></i>
              <!-- {{'NAVBAR.PROFILE' | translate}} -->
              {{nickname$ | async}}
            </button>
            <ul class="dropdown-menu" style="min-width: 78px;">
              <li>
                <a class="dropdown-item" [routerLink]="['/profile/settings']">{{'NAVBAR.SETTINGS' | translate}}</a>
              </li>
              <li>
                <a class="dropdown-item logout" (click)="logout()">{{'NAVBAR.LOGOUT' | translate}}</a>
              </li>
            </ul>
          </div>
        </li>
        <li *ngIf="!isToggle" class="nav-item d-flex align-items-center mb-1">
          <app-language></app-language>
        </li>

        <li *ngIf="isToggle" class="nav-item d-flex align-items-center mb-1 ml-3">
          <a class="nav-link" href="/profile/settings"
            [ngStyle]="{'border-bottom': isCurrentPage('/profile') ? '2px solid #FF0000' : 'none'}">
            {{'NAVBAR.PROFILESETTINGS' | translate}}
          </a>
        </li>
        <li *ngIf="isToggle" class="nav-item d-flex align-items-center mb-1 ml-3">
          <button class="btn nav-link" (click)="logout()">
            {{'NAVBAR.LOGOUT' | translate}}
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>
